import React, { createContext, useContext, useState } from "react";
import { ModelDetailRepository } from "../../repository/AdminDashboard/DeviceModelRepository";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";


const StateContext = createContext();

const initialState = {};

const ModelDetailContext = ({ children }) => {
  const [sensoreArray, setsensoreArray] = useState([]);
  const [details, setdetails] = useState({});
  const [loaded, setloaded] = useState(false);
  const [showDeleteModal, setshowDeleteModal] = useState(false);
  const [idD, setid] = useState("");
  const [quality, setquality] = useState(true);
  const [showJson, setshowJson] = useState(false);
  const [json, setjson] = useState({});

  // Function to fetch model details
  const getdata = async (id) => {
    setloaded(true);
    const data = await ModelDetailRepository.getDetail(id);
    setdetails(data.details);
    setsensoreArray(data.details.sensore);
    setid(details.id);

    if (data.details.testType === "مقدار سنج") {
      setquality(false);
    } else if (data.details.testType === "کیفیت سنج") {
      setquality(true);
    }
    setloaded(false);
  };

   // Navigation hook
  const navigate = useNavigate();

  // Function to delete model
  const deleteModel = async () => {
    const data = await ModelDetailRepository.delete(idD);
    if (data.code == 1) {
      navigate("/device/models/");
      setTimeout(() => {
        toast.success(data.massage, {
          className: "text-12 text-dark-blue-200",
        });
      }, 1000);
    } else if (data.code == 0) {
      toast.error(data.massage, {
        className: "text-12 text-dark-blue-200",
      });
    }
  };
 

  // Function to handle model deletion,open modal
  const onDelete = () => {
    setshowDeleteModal(true);
  };

    // Function to close device deletion modal
  const closeDeleteModal = () => {
    setshowDeleteModal(false);
  };

    // Function to remove model
  const RemoveItem = async () => {
    setshowDeleteModal(false);
    await deleteModel(details.id);
  };
 
// open the modal wich shoe the json of model
  const onjson = () => {
    const a = {};

    if (details.testType === "کیفیت سنج") {
      a["IAQ_Index"] = 2;
      details.sensore.forEach((s) => {
        a[`${s.jsonname}_Index`] = 2;
      });
    }

    details.sensore.forEach((s) => {
      a[`${s.jsonname}_Value`] = 2;
    });
    setjson(a);
    setshowJson(true);
  };

 //  copy json to the clipboard 
  const copyJson = () => {
    const jsonText = JSON.stringify(json, null, 2);
    navigator.clipboard.writeText(jsonText);
    toast.success("متن کپی شد", {
      className: "text-12 text-dark-blue-200",
    });
    setshowJson(false);
  };

   // clese the modal wich one shows the json string
  const closemodal = () => {
    setshowJson(false);
  };

  return (
    <StateContext.Provider
      value={{
        sensoreArray,
        quality,
        details,
        loaded,
        onDelete,
        RemoveItem,
        closeDeleteModal,
        getdata,
        showDeleteModal,
        showJson,
        closemodal,
        json,
        copyJson,
        // editpath,
        onjson,
      }}>
      {children}
    </StateContext.Provider>
  );
};

function ModelsDetailUseContext() {
  return React.useContext(StateContext);
}

export { ModelsDetailUseContext };
export default ModelDetailContext;
